module.exports = __webpack_public_path__ + "static/media/model-mission-18.a7d55fe7.png";